import type { FaireProductEntity } from "../../entity_types/product";

export const p_b444c9aspp: FaireProductEntity = {
  token: "p_b444c9aspp",
  type: "product",
  name: "You Are Awesome Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d7b89e2fe46ef9244cff678935292d393e78a745805fd90303d2665a31fd3e46.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5c02b0d2fd63b3132b8668b5e634394b20956e3c8aa5ed0aaaf2c35ff77f0eb2.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:40.767Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
